import React from 'react';
import './PromozioniBody.css';
import EmailFormIT from '../../components/EmailFormIT/EmailFormIT';
import useMediaQuery from '../../../hooks/useMediaQuery';

const PromozioniBody = ({
  title,
  headline,
  subheadline,
  picURL,
  backgroundPic1,
  backgroundPic2,
  textColorDesktop,
  textColorMobile,
  campaignName,
  translations
}) => {
  const isUnder800 = useMediaQuery('(max-width: 800px)');

  return (
    <div className='rewards-body-container-main'>
      <div className="rewards-body-container">
        <div
          className="reward-body-item"
          id="body-photo-rewards"
          style={{ backgroundImage: `url(${backgroundPic1})` }}
        ></div>
        <div
          className="reward-body-item"
          style={{ backgroundImage: isUnder800 ? `url(${backgroundPic2})` : '' }}
        >
          <h2
            className="rewards-headline-text"
            style={{ color: isUnder800 ? textColorMobile : textColorDesktop }}
          >
            Sei idoneo per {headline}
          </h2>
          {subheadline && (
            <p className="subheadline-text" style={{ color: isUnder800 ? textColorMobile : textColorDesktop }}>
              {subheadline}
            </p>
          )}
          {picURL && <img id="promo-image" src={picURL} alt={headline} />}
          <br />
          <br />
          <div>
            <EmailFormIT 
              picURL={picURL} 
              pageType="promozioni" 
              campaignName={campaignName}
              translations={translations}
            />
            <div className="disclaimer3">
              *AL COMPLETAMENTO DELL'ACQUISTO E DEI REQUISITI DEL PROGRAMMA. I nomi commerciali 
              o i diritti associati a tutti i marchi su questo sito sono di proprietà dei 
              rispettivi proprietari e non sono affiliati con questa promozione.
            </div>
          </div>
          <br />
        </div>

        <div className="rewards-additional-info"></div>
      </div>
    </div>
  );
};

export default PromozioniBody;
